import { useTranslation } from "@flare/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import { ChoiceBoxContent } from "./components/choice-box-content";
import type { StepProps } from "./step.types";

export default function ChildAge({ answers }: StepProps) {
  const { t } = useTranslation();
  const { sponsorType } = answers;
  const contentTitle =
    sponsorType === "parent"
      ? t("FUNNEL_CHILD_AGE_TITLE_PARENT_SPONSOR")
      : t("FUNNEL_CHILD_AGE_TITLE");

  const choices = [
    {
      label: t("FUNNEL_CHILD_AGE_CHOICE_YES"),
      value: "Yes",
    },
    {
      label: t("FUNNEL_CHILD_AGE_CHOICE_NO"),
      value: "No",
    },
  ];

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{contentTitle}</StepTitle>
          <ChoiceBoxContent
            name={funnelInputsNameMap.isChildUnderTwentyOne}
            choices={choices}
            required
          />
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
